import { render, staticRenderFns } from "./NoNotifications.vue?vue&type=template&id=23da0856&scoped=true&"
import script from "./NoNotifications.vue?vue&type=script&lang=js&"
export * from "./NoNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da0856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23da0856')) {
      api.createRecord('23da0856', component.options)
    } else {
      api.reload('23da0856', component.options)
    }
    module.hot.accept("./NoNotifications.vue?vue&type=template&id=23da0856&scoped=true&", function () {
      api.rerender('23da0856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Notifications/NoNotifications.vue"
export default component.exports